import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0cdbfc57&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./index.styl?vue&type=style&index=0&id=0cdbfc57&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdbfc57",
  null
  
)

export default component.exports